import { getLocalizedString } from "owa-datetime-formatters-core";
import { format } from "owa-localize";
import { localizedFormatter } from "./localizedFormatter";
import type { OwaDate, GlobalCalendarLocale } from "owa-datetime";

export function getWeekDayDateTimeWithAtFormat(dateFormat: string, timeFormat: string): string {
    return format(getLocalizedString("weekDayDateTimeWithAtFormat"), dateFormat, timeFormat);
}

const defaultExport: (date: OwaDate | null | undefined, locale?: GlobalCalendarLocale) => string = 
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function localizedFormatter called at module scope is not allowed. This may cause unwanted side effects. */
localizedFormatter(getWeekDayDateTimeWithAtFormat);
export default defaultExport;
